import logError from "commons/utils/logError";
import ApiService from "services/ApiService";
import {REMEMBER_ME} from "services/Auth";
import history from "./history";

const URL = process.env.REACT_APP_API_URL;

function isApiClient(value) {
  return value != null && typeof value.get === "function";
}

class Service {
  constructor(apiClientOrHistory = ApiService) {
    if (isApiClient(apiClientOrHistory)) {
      this.apiClient = apiClientOrHistory;
    } else {
      this.apiClient = ApiService;
      this.history = apiClientOrHistory;
    }
  }

  checkStatus(status) {
    const rememberMeEnabled = localStorage.getItem(REMEMBER_ME);
    if (status === 401 && rememberMeEnabled !== 'true') {
      history.push("/");
    }

    if (status === 403) {
      history.push('/');
    }

    return false;
  }

  get(path, onSuccess, onError, signal) {
    this.apiClient.get(path, !!signal ? {signal} : {})
        .then((response) => {
          if (response.status === 200) {
            onSuccess(response.data);
            return response.data;
          } else {
            if (!this.checkStatus(response.status)) {
              onError(response.status);
            }
          }
        })
    .catch((err) => {
      console.error(err);
        onError(err);
    });
  }

  post(path, data, onSuccess, onError) {
    this.apiClient.post(path, data)
    .then((response) => {
      if (response.status === 200) {
        onSuccess(response.data);
        return response.data;
      } else {
        if(!this.checkStatus(response.status)) {
          onError(response.status);
        }
      }
    })
    .catch((err) => {
      console.error(err);
      onError(err);
    });
  }

  async getWaiting(path) {
    try {
      const response = await this.apiClient.get(path);
      this.checkStatus(response.status);
      return response.data;
    } catch (error) {
      console.error(error);
      return error.data;
    }
  }

  async postWaiting(path, data) {
    try {
      const response = await this.apiClient.post(path, data);
      this.checkStatus(response.status);
      return response.data;
    } catch (error) {
      console.error(error);
      return error.data;
    }
  }

  async put(path, data) {
    try {
      if(!data) throw new Error("Body is required");
      const response = await this.apiClient.put(path, data);
      return response.data;
    } catch(error) {
      return { error };
    }
  }

  async delete(path, config) {
    try {
      const response = await this.apiClient.delete(path, config);
      this.checkStatus(response.status);
      return response.data;
    } catch (error) {
      logError("Service.delete", error);
      return { error };
    }
  }
}

export { URL, Service };
